import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { RoleListDescriptionCell } from './role-list-description.cell';
import { RoleListDescriptionHeader } from './role-list-description.header';

export const RoleListDescriptionColumn: IdentifiedColumnDef<
  GatewayRoleModel,
  GatewayRoleModel['description']
> = {
  enableSorting: false,
  header: RoleListDescriptionHeader,
  cell: RoleListDescriptionCell,
};
